import styled, { css } from "styled-components";

interface StyledSelectFolderListProps {
  $size: "large" | "medium" | "small";
  $isOpen: boolean;
}

export const StyledSelectFolderList = styled.div<StyledSelectFolderListProps>`
  position: relative;
  box-sizing: border-box;
  width: 100%;
  padding: 0.4rem;
  padding-bottom: 0;
  height: max-content;
  z-index: 100;
  background-color: var(--bg-gray-normal);
  .field-wrap {
    width: 100%;
    padding-bottom: 0.3rem;
    border-bottom: ${({ $isOpen }) =>
      $isOpen
        ? "0.1rem solid var(--bg-gray-strong)"
        : "0.1rem solid var(--bg-gray-2)"};

    .field {
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
      gap: 0.4rem;
      border-radius: 0.4rem;
      cursor: pointer;
      height: ${({ $size }) =>
        $size === "large" ? "2.2rem" : $size === "medium" ? "2rem" : "1.2rem"};
      padding: ${({ $size }) =>
        $size === "large" ? "0.5rem 0.4rem" : "0 0.4rem"};
      ${({ $size }) => {
        if ($size === "large") {
          return css``;
        }
        if ($size === "medium") {
          return css``;
        }
      }}
      &:hover {
        background-color: var(--hovered);
      }
    }
  }
`;
